<template>
    <div class="confirmation">

        <div class="confirmation_area" v-if="pageLoad && success">
            <div class="confirmation_div">
                <div class="confirmation_inner_div">

                    <div class="order_success_area">
                        <div class="order_success_icon success"></div>
                        <div class="order_success_message">{{label['conformation_success_header_text']}}</div>                        
                    </div>

                    <div class="order_message_area" v-html="ConfirmationContentMsg">
                    </div>

                    <div class="order_no_area">
                        <div class="order_no_text">
                            {{label['conformation_success_order_no_text']}}:
                        </div>
                        <div class="order_no">
                            {{order.orderCode}}
                        </div>
                    </div>
                    
                    <div class="page_bottom_btn_div">
                        <div class="save_order_info_div" :class="{ checked: saveOrderInfo }" @click="confirmSavePayInfo()" v-if="showSavePayInfo()">
                            <div class="tickicon"></div>
                            <div class="save_order_text">
                                {{label['conformation_success_message_text_save_pay_info']}}
                            </div>
                        </div>
                        <div class="bottom_btn" @click="exit()" v-if="info.order_temp_info.order_device == 'web'">{{label['conformation_success_back_home_btn_text']}}</div>
                    </div>

                </div>
            </div>
        </div>


        <div class="confirmation_area" v-if="pageLoad && !success">
            <div class="confirmation_div">
                <div class="confirmation_inner_div">

                    <div class="order_success_area">
                        <div class="order_success_icon fail"></div>
                        <div class="order_success_message" v-html="fail_message"></div>
                    </div>

                    <div class="order_message_area" v-html="ConfirmationContentMsg">
                    </div>

                    <div class="order_no_area" v-if="orderNo != '' && errorShowOrderNo">
                        <div class="order_no_text">
                            {{label['conformation_success_order_no_text']}}:
                        </div>
                        <div class="order_no">
                            {{orderNo}}
                        </div>
                    </div>

                    <div class="page_bottom_btn_div">
                        <div class="bottom_btn" @click="goBackFail()">{{label['conformation_fail_my_event_btn_text']}}</div>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>
 
<script>

    export default {
        data() {
            return {
                pageLoad: false,

                success: false,
                order: undefined,
                orderNo: "",
                errorShowOrderNo: true,
                retry: 0,
                checking: false,

                ConfirmationContentMsg: "",
                fail_message: "",

                cc_paymentType: ['eft_VM'],
                saveOrderInfo:false
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },

        },
        components: { },
        created() {
            this.$root.getCurrentPathName();
            if (this.info.member != null) {

                this.info.loading = false;

                this.info.canGoBack = false;                

                if (this.info.orderResult == undefined && this.$root.getParameterByName("orderNo") == null) {
                    this.$router.replace(`/` + this.info.lang + "/");
                }
                else if (this.info.orderResult) {
                    this.success = true;
                    this.showResult();
                }
                else {
                    var app = this;
                    app.orderNo = this.$root.getParameterByName("orderNo");
                    if ((app.orderNo || "") == "") {
                        app.orderNo = "";
                        this.showResult();
                        return;
                    }
                    //window.history.replaceState(null, null, this.info.currentPathName);
                    window.history.replaceState(null, null, ("/" + this.info.lang + this.info.currentPathName));
                    app.info.loading = true;
                    app.getOrderResult();
                }

                this.fail_message = this.label['conformation_fail_header_text'];

            }
            else {
                this.$router.replace(`/` + this.info.lang + "/");
            }
        },
        destroyed() {
            this.$root.setGoBackAction();
        },
        watch: {
            '$root.info.member': function (member) {
                if (member == null) {
                    //this.$root.ReloadCurrentPage();
                    this.$router.push(`/` + this.info.lang + `/`);
                }
            }
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },

            getOrderResult() {
                this.info.loading = true;
                var app = this;                

                // check orderNo preent double fire the event
                if (app.$root.getLocalStorageItemArr("orderNo").indexOf(app.orderNo) >= 0) {
                    app.$router.replace("/" + app.info.lang + "/member/eventhistory");
                }
                else {
                    app.$root.setLocalStorageItemArr("orderNo", app.orderNo);

                    app.getOrderAjax();
                }
                    
            },
            getOrderAjax() {
                var app = this;
                app.retry++;

                if (!app.checking) {                    
                    app.checking = true;

                    $.ajax({
                        type: "POST",
                        headers: { lang: app.info.lang, memberToken: app.info.member.memberToken },
                        url: app.info.wsUrl + "/Order/CheckEventOrderStatus?orderCode=" + encodeURIComponent(app.orderNo),
                        contentType: "application/json",
                        dataType: "json",
                        success: (data) => {
                            console.log("CheckEventOrderStatus", data);

                            //var exit = app.retry > 20;
                            //var exit = app.retry > 10;
                            var exit = app.retry > 5;
                            var isContinue = true;

                            if (!exit) {
                                if (data.status == 0 || data.status == 55) {

                                    if (app.info.member.memberNumber == data.orderCore.memberCode) {
                                        app.order = data.orderCore;
                                        app.success = true;
                                        exit = true;
                                        app.retry = 100;
                                    }
                                    else {
                                        exit = true;
                                        app.retry = 100;
                                        this.$router.replace("/" + app.info.lang + "/member/eventhistory");
                                    }

                                }
                                else if (data.status == 66) {
                                    exit = true;
                                    app.retry = 100;
                                    this.$router.replace("/" + app.info.lang + "/member/eventhistory");
                                }
                                else {

                                    if (data.status == 1 ||
                                        data.status == 4
                                    ) {
                                        exit = true;
                                        app.retry = 100;
                                        //app.$root.alert(data.detail);
                                        app.errorShowOrderNo = false;
                                        app.LoadConfirmationContentMsg('conformation_fail_message_text_common_fail_message');
                                    }
                                    else if (data.status == 2 ||
                                        data.status == 3
                                    ) {
                                        //exit = true;
                                        //app.$root.alert(data.detail);
                                        //app.LoadConfirmationContentMsg('conformation_fail_message_text_inner_content_check_payment_fail');
                                    }
                                    else {

                                        if (data.status == 98) {                                            
                                            exit = true;
                                            app.retry = 100;
                                            app.info.orderResult = undefined;
                                            app.$root.removeInfoMemberData();
                                            app.$root.ReloadCurrentPage();
                                        } else {
                                            // continue check payment
                                        }

                                    }

                                }
                            } // end exit
                            else {
                                app.retry = 100;
                                app.LoadConfirmationContentMsg('conformation_fail_message_text_inner_content_check_payment_fail');
                            }

                            app.checking = false;
                            if (isContinue) {
                                if (exit) {
                                    app.info.loading = false;
                                    app.showResult();
                                } else {
                                    //setTimeout(app.getOrderAjax, 500);
                                    setTimeout(app.getOrderAjax, 1000);
                                }
                            }

                        } // end success
                    });
                } // end app.checking
                else {
                    if (app.retry <= 5) {
                        setTimeout(app.getOrderAjax, 1000);
                    }
                    else {
                        app.info.loading = false;
                        app.showResult();
                    }

                }
            },

            showResult() {
                var app = this;
                var gathis = this;
                this.pageLoad = true;

                if (this.info.orderResult) {
                    this.order = JSON.parse(JSON.stringify(this.info.orderResult));
                    this.orderNo = this.order.orderCode;
                    this.info.orderResult = undefined;
                    
                    gathis.$root.NFGA_FillParam("NFGA_page_view", "'" + app.order.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.order.eventObj.mall.NFMallID + "'", "'" + app.order.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + app.order.orderCode + "'");
                }

                if (this.success) {
                    console.log("this.order", this.order);

                    if (this.order.orderStatus == "complete") {
                        this.LoadConfirmationContentMsg('conformation_success_message_text_inner_content');
                    }
                    else if (this.order.orderStatus == "waiting") {
                        this.LoadConfirmationContentMsg('conformation_success_message_text_inner_content_waiting_list');
                    }
                    else {
                        this.LoadConfirmationContentMsg('unknown status');
                    }

                    // ga start
                    if (typeof WebOnGAObj != 'undefined') {
                        //RunTransactionGA(this.order);
                    }
                    // ga end

                    // clear data
                    this.$root.clearAllStoreData();
                } else {                    
                    this.$root.setGoBackAction(this.goBack);                    
                    this.fail_message = this.label['conformation_fail_header_text'];

                    // clear data
                    this.$root.clearAllStoreData();
                }
            },

            exit() {
                var app = this;
                var gathis = this;
                if (app.order != null) {
                    gathis.$root.NFGA_FillParam("NFGA_Back_to_Home", "'" + app.order.eventObj.eventTitleEN.replace(/\'/g, "\\\'") + "'", "'" + app.order.eventObj.mall.NFMallID + "'", "'" + app.order.eventObj.mall.mallName.replace(/\'/g, "\\\'") + "'", "'" + app.order.orderCode + "'");
                }

                if (this.$root.finishAction) {
                    eval(this.$root.finishAction);
                    return;
                } else if (this.$root.exitAction) {
                    eval(this.$root.exitAction);
                    return;
                }
                this.$router.replace(`/` + this.info.lang + "/");
            },
            goBack() {
                this.$router.push(`/` + this.info.lang + "/");
                return true;
            },
            goBackFail() {
                this.$router.push(`/` + this.info.lang + "/member/eventhistory");
                return true;
            },

            showSavePayInfo() {
                /*
                if (this.cc_paymentType.indexOf(this.order.paymentType) >= 0) {
                    return true;
                }
                else {
                    return false;
                }
                */
                return false;
            },
            confirmSavePayInfo() {
                var app = this;
                if (!app.saveOrderInfo) {
                    app.$root.setConfirmMsg(app.label["conformation_success_message_text_save_pay_info_confirm"], app.confirmSavePayInfoClick, undefined);
                }
            },
            confirmSavePayInfoClick() {
                this.saveOrderInfo = true;
            },

            LoadConfirmationContentMsg(labelCode) {
                this.ConfirmationContentMsg = this.label[labelCode];
            },

        },
    };
</script>

